import clsx from 'clsx'
import React, { useContext, useMemo } from 'react'

import { ProductContext } from '@Components/Product/Context'
import SliderProvider from '@Components/Product/Slider'
import { getGalleryAssets } from '@Domains/Product/Features/Display/GalleryAssets'
import ProductSliders from '@Domains/Product/Features/Display/ProductSliders/ProductSliders'
import spacingStyles from '@Domains/Product/Features/Display/spacing.module.scss'
import { GiftCardInfo } from '@Domains/Product/Features/GiftCard/Info'

import styles from './GiftCard.module.scss'

export const GiftCardDisplay = () => {
  const product = useContext(ProductContext)
  const assets = useMemo(() => getGalleryAssets(product), [product])

  if (!product) {
    return <>404</>
  }

  return (
    <div className={clsx(styles.wrapper, spacingStyles.spacing)}>
      <div className={styles.content}>
        <div className={styles.layout}>
          <div className={styles.slider}>
            <SliderProvider slides={assets}>
              <ProductSliders />
            </SliderProvider>
          </div>
          <div className={styles.info}>
            <GiftCardInfo />
          </div>
        </div>
      </div>
    </div>
  )
}
